import { CommonUIModule } from '../webpack';
/** @component React Components */
export const TextField = Object.values(CommonUIModule).find((mod) => mod?.validateUrl && mod?.validateEmail);
